import React, { useMemo, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import moment from "moment";
import { Card, Select, Space } from "@masterteam/mt-design-react";

import MeasuresChart from "../../../MeasuresChart";

import { ReactComponent as StatusIcon } from "../../../../assets/images/status-icon.svg";

import useIsAr from "../../../../Hooks/useIsAr";
import { getKPIYears, addToast } from "../../../../helpers";
import api from "../../../../providers/api";

import "./style.scss";

function HistoricalPerformance({
  item: {
    KPIMeasures,
    Frequency,
    UnitOfMeasure,
    KPIType,
    HasNoTarget,
    HasNoBaseline,
    ID
  }
}) {
  const [isAr] = useIsAr();
  const frequencies = useSelector(({ theme }) => theme.Frequencies.item.Items);
  const HasNoTargetBaseline = HasNoTarget || HasNoBaseline;
  const getOptions = (arr) => {
    return arr.sort((a, b) => a.Order0 - b.Order0);
  };

  const tabs = useMemo(
    () =>
      UnitOfMeasure === "Percentage"
        ? [
            {
              ID: 1,
              Value: "periodic"
            }
          ]
        : [
            {
              ID: 1,
              Value: "periodic"
            },
            {
              ID: 2,
              Value: "accumulative"
            }
          ],
    []
  );
  const [activeTab, setActiveTab] = useState("periodic");
  const [kpiMeasures, setKpiMeasures] = useState(KPIMeasures);
  const [frequency, setFrequency] = useState(null);

  const currentFrequency = frequencies.find(
    (t) => t.Value.toLowerCase() === Frequency?.toLowerCase()
  );
  const isAnnual = frequency?.Value?.toLowerCase() === "annual";

  const Years = getKPIYears(kpiMeasures);
  const [selectedOption, setSelectedOption] = useState(Years[0]);

  const getMeasures = async (id, frequency) => {
    try {
      const res = await api.kpi.getMeasures(id, frequency);
      setKpiMeasures(res.Data || []);
    } catch (err) {
      addToast.error(err.message, {
        toastId: "get-users-error"
      });
    }
  };

  return (
    <Card className="historical-performance-container">
      <Space direction="vertical" style={{ height: "100%" }}>
        <div className="historical-performance-container_header">
          <div className="historical-title">
            <FormattedMessage id="kpi.details-Historical-performance-timeline" />
          </div>
          <Space size="large" align="center">
            {currentFrequency?.Value?.toLowerCase() === "annual" ? null : (
              <div
                className="frequencies-select"
                style={{ direction: isAr ? "rtl" : "ltr" }}
              >
                <Select
                  options={getOptions(
                    frequencies.filter(
                      (e) => +e?.Order0 > +currentFrequency?.Order0
                    )
                  )}
                  placeholder={<FormattedMessage id="common.select" />}
                  getOptionLabel={(el) => (isAr ? el.Arabic : el.English)}
                  getOptionValue={(el) => el?.Value}
                  onChange={(item) => {
                    setFrequency(item);
                    if (item) getMeasures(ID, item.Value);
                    else setKpiMeasures(KPIMeasures);
                  }}
                  value={frequency}
                  isClearable
                />
              </div>
            )}

            <Card gap={0} className="filter-wrapper">
              {tabs.map((item) => (
                <Space
                  key={item.ID}
                  align="center"
                  onClick={() => setActiveTab(item.Value)}
                  className={`filter-item cursor ${
                    activeTab === item.Value && "active"
                  }`}
                >
                  <FormattedMessage id={`kpi-info.${item.Value}`} />
                </Space>
              ))}
            </Card>
            {/* {isAnnual ? null : (
              <div className="select">
                <Select
                  className="select-year "
                  value={selectedOption}
                  onChange={(e) => setSelectedOption(e)}
                  options={Years}
                />
              </div>
            )} */}
          </Space>
        </div>
        <Space size="large" align="center" className="status-container">
          <Space align="center">
            <span>
              <FormattedMessage id="kpi-list.target" />
            </span>
            <StatusIcon stroke={HasNoTargetBaseline ? "black" : "#55565a"} />
          </Space>
          <Space align="center">
            <span>
              <FormattedMessage id="common.actual" />
            </span>
            <StatusIcon stroke="#CECECE" />
          </Space>
        </Space>

        <div
          className="measure-chart-wrapper"
          style={{ direction: isAr ? "rtl" : "ltr" }}
        >
          <div
            style={{
              width: kpiMeasures?.length * 100,
              height: "100%",
              minWidth: "100%"
            }}
          >
            <MeasuresChart
              isAccumulative={activeTab === "accumulative"}
              kpiFrequency={frequency?.Value || currentFrequency?.Value}
              data={kpiMeasures}
              // data={
              //   isAnnual
              //     ? kpiMeasures
              //     : kpiMeasures?.filter(
              //         (_item) =>
              //           +moment(_item.DueDate).format("YYYY") ===
              //           +selectedOption?.value
              //       )
              // }
              UnitOfMeasure={UnitOfMeasure}
              statuses={KPIType?.Status}
              HasNoTargetBaseline={HasNoTargetBaseline}
              statusColor
            />
          </div>
        </div>
      </Space>
    </Card>
  );
}

export default HistoricalPerformance;
